import { useEffect, useState } from 'react';
import { loggedIn } from "../components/common";
import { subS3bucketsBreadcrumbs } from "../components/common";

import { useNavigate } from 'react-router-dom';
import { NewS3bucketForm } from "../components/new-s3bucket-form";

import {
  BreadcrumbGroup,
} from '@cloudscape-design/components';

import '../css/base.scss';

const Breadcrumbs = ({navigate, item}) => (
  <BreadcrumbGroup
    onFollow={event => {
      event.preventDefault();
      navigate(event.detail.href);
    }}
    items={subS3bucketsBreadcrumbs(item)}
    expandAriaLabel="Show path"
    ariaLabel="Breadcrumbs" />
)

export default function NewS3bucket({ state }) {
  const navigate = useNavigate();
  if (!loggedIn()) {
    return null;
  }
  useEffect(() => {
    state.activeHref.setHref("/s3buckets");
    state.breadCrumbs.setCrumbs(
      <Breadcrumbs navigate={navigate} item="Create S3 Bucket" />
    )
    state.maxContentWidth.setWidth(Number.MAX_VALUE);
    state.contentType.setType("default");
  }, []);
  return (
      <NewS3bucketForm resource="S3 Bucket" url="s3buckets" flashbar={state.flashBar}/>
  );
}
